<template>
	<div>
		<!-- 检索条件 -->
		<div>
			<el-form :inline="true" @submit.native.prevent>
				<el-row>
					<el-form-item :label="item.fieldShow+':'" v-for="(item,index) in searchTermList" :key="index"
						v-show="item.isShow == 1">
						<el-input style="width:200px" v-if="item.fieldType == 'string' && item.isShow"
							@change="((val)=>{handleChange(val,item.fieldEntity)})" :placeholder="'请输入'+item.fieldShow"
							v-model.trim="item.value" size="mini">
						</el-input>
						<el-date-picker v-else-if="item.fieldType == 'date' && item.isShow"
							@change="((val)=>{handleChange(val,item.fieldEntity)})" size="mini" v-model="item.value"
							format="yyyy 年 MM 月 dd 日" value-format="timestamp" type="date" placeholder="选择日期">
						</el-date-picker>
						<el-input style="width:200px" v-else-if="item.fieldType == 'number' && item.isShow"
							@change="((val)=>{handleChange(val,item.fieldEntity)})" :placeholder="'请输入'+item.fieldShow"
							v-model.number="item.value" size="mini">
						</el-input>
						<el-select size="mini" v-else-if="item.fieldType == 'formatter' && item.isShow"
							@change="((val)=>{handleChange(val,item.fieldEntity)})" v-model="item.value"
							placeholder="请选择">
							<el-option v-for="matItem in JSON.parse(item.formatterContent)" :key="matItem.key"
								:label="matItem.key" :value="matItem.value">
							</el-option>
						</el-select>
					</el-form-item>
					<el-form-item>
						<el-button type="primary" size="mini" @click="searchData">查询</el-button>
					</el-form-item>
				</el-row>
			</el-form>
		</div>
		<!-- 表格 -->
		<el-table ref="multipleTable" height="420" size="mini" @row-click="handleClick" style="width: 100%"
			:data="tableData" border stripe highlight-current-row :header-cell-style="getHeaderCellStyle">
			<template v-for="(item, index) in Columns">
				<!-- 数字 -->
				<el-table-column v-if="item.fieldType == 'formatter' && item.isShow" align="center" :key="index"
					min-width="120" :prop="item.fieldEntity" :sortable="item.isSort" :label="item.fieldShow"
					:show-overflow-tooltip="true">
					<!-- 各种状态判断 -->
					<template slot-scope="scope">
						<el-tag size="mini" type="primary">
							{{JSON.parse(item.formatterContent)[scope.row[item.fieldEntity]].value}}</el-tag>
					</template>
				</el-table-column>
				<el-table-column v-else-if="item.fieldType == 'string' && item.isShow" align="center" :key="index + 'a'"
					min-width="120" :prop="item.fieldEntity" :sortable="item.isSort" :label="item.fieldShow"
					:show-overflow-tooltip="true">
				</el-table-column>
				<el-table-column v-else-if="item.fieldType == 'date'  && item.isShow" align="center" :key="index + 'b'"
					min-width="120" :prop="item.fieldEntity" :sortable="item.isSort" :label="item.fieldShow"
					:show-overflow-tooltip="true">
					<template slot-scope="scope">
						<span>{{$common.getLocalTime(scope.row[item.fieldEntity])}}</span>
					</template>
				</el-table-column>
				<el-table-column v-else-if="item.fieldType == 'number' && item.isShow" align="center" :key="index +'c'"
					min-width="120" :prop="item.fieldEntity" :sortable="item.isSort" :label="item.fieldShow"
					:show-overflow-tooltip="true">
				</el-table-column>
			</template>
			<el-table-column v-if="!isDetail" fixed="right" label="操作" width="110" align="center">
				<template slot-scope="scope">
					<el-button size="mini" type="text" @click.stop="handleSelectClick(scope.row)">确认选择</el-button>
				</template>
			</el-table-column>
		</el-table>
		<!-- 分页 -->
		<el-pagination v-if="isPagination" @size-change="handleSizeChange" @current-change="handleCurrentChange"
			:current-page="currentPage" :page-sizes="pageSizes" background :page-size="pageSize"
			layout="total, sizes, prev, pager, next, jumper" :total="total">
		</el-pagination>
		<el-collapse v-model="activeName" accordion>
			<el-collapse-item name="1" :disabled="true">
				<template slot="title">
					<el-switch style="display: block" @change="showDetailChange" v-model="showdetail" active-text="展示明细"
						inactive-text="关闭明细">
					</el-switch>
					<el-button v-if="isDetail" size="mini" @click="sureDetail" style="margin-left: 60px"
						:disabled="detailsub" type="primary">确认选择</el-button>
					<el-tag v-else size="mini" style="margin-left: 60px">明细表格</el-tag>
				</template>
				<!-- 明细表 -->
				<el-table size="mini" @selection-change="handleSelectionChange" height="280" :data="detailData" border
					stripe highlight-current-row :header-cell-style="getHeaderCellStyleD" style="width: 100%">
					<el-table-column v-if="isDetail" type="selection" width="50">
					</el-table-column>
					<template v-for="(item, index) in ColumnsDetail">
						<!-- 数字 -->
						<el-table-column v-if="item.fieldType == 'formatter' && item.isShow" align="center" :key="index"
							min-width="120" :prop="item.fieldEntity" :sortable="item.isSort" :label="item.fieldShow"
							:show-overflow-tooltip="true">
							<!-- 各种状态判断 -->
							<template slot-scope="scope">
								<el-tag size="mini" type="primary">
									{{JSON.parse(item.formatterContent)[scope.row[item.fieldEntity]].value}}</el-tag>
							</template>
						</el-table-column>
						<el-table-column v-else-if="item.fieldType == 'string' && item.isShow" align="center"
							:key="index + 'd'" min-width="120" :prop="item.fieldEntity" :sortable="item.isSort"
							:label="item.fieldShow" :show-overflow-tooltip="true">
						</el-table-column>
						<el-table-column v-else-if="item.fieldType == 'date' && item.isShow" align="center" :key="index + 'f'"
							min-width="120" :prop="item.fieldEntity" :sortable="item.isSort" :label="item.fieldShow"
							:show-overflow-tooltip="true">
							<template slot-scope="scope">
								<span>{{$common.getLocalTime(scope.row[item.fieldEntity])}}</span>
							</template>
						</el-table-column>
						<el-table-column v-else-if="item.fieldType == 'number' && item.isShow" align="center"
							:key="index +'e'" min-width="120" :prop="item.fieldEntity" :sortable="item.isSort"
							:label="item.fieldShow" :show-overflow-tooltip="true">
						</el-table-column>
					</template>
				</el-table>
			</el-collapse-item>
		</el-collapse>
	</div>
</template>
<script>
	export default {
		name: "newExtractionScheme",
		components: {},
		data() {
			return {
				opmId: "",
				ormId: "",
				detailsub: true,
				activeName: "0",
				showdetail: false,
				detailData: [],
				currentPage: 1,
				pageSizes: [10, 25, 50, 100],
				pageSize: 10,
				total: 0,
				tableData: [],
				isPagination: "",
				queryMap: {},
				searchTermList: [], //检索条件
				Columns: [],
				ColumnsDetail: [],
				isDetail: false,
				multipleSelection: [], //数组内层
				objList: [], //外层数组
				searchKey: 'woamId'
			};
		},

		props: {
			toExtractObj: {
				type: Object,
				require: true,
			},
		},
		created() {
			this.toExtractObj.conditionList.forEach((item) => {//检索信息
				item.value = "";
			});
			this.toExtractObj.tableMainList.forEach((item) => {//主表表头信息
				item.isShow == 1 ? (item.isShow = true) : (item.isShow = false);
				item.isSort == 1 ? (item.isSort = true) : (item.isSort = false);
			});
			this.toExtractObj.tableDetailList.forEach((item) => {//明细表头信息
				item.isShow == 1 ? (item.isShow = true) : (item.isShow = false);
				item.isSort == 1 ? (item.isSort = true) : (item.isSort = false);
			});
			// this.$emit("getWidth", width);
			// this.$emit("sendTitle", extractName);
			this.pageSizes = this.toExtractObj.pageCount.split(",");
			this.isDetail = this.toExtractObj.isDetail;
			if (this.isDetail) {
				this.showdetail = true;
				this.activeName = "1";
			} else {
				this.showdetail = false;
				this.activeName = "0";
			}
			this.Columns = this.toExtractObj.tableMainList;
			this.ColumnsDetail = this.toExtractObj.tableDetailList;
			this.searchTermList = this.toExtractObj.conditionList;
			this.isPagination = this.toExtractObj.isPagination == 0 ? false : true; //是否分页
			this.pageSize = parseInt(this.pageSizes[0]);//选取第一项的数量为一页数据
			// 根据返回数据处理一些页面逻辑
			// 添加请求参数
			for (const key in this.toExtractObj.childData) {
				if (Object.hasOwnProperty.call(this.toExtractObj.childData, key)) {
					const element = this.toExtractObj.childData[key];
					this.queryMap[key] = element
				}
			}
			if (this.isPagination == true) {// 需要分页
				this.queryMap.page = this.currentPage
				this.queryMap.rows = this.pageSize
			}
			this.queryMap.extractId = this.toExtractObj.extractId
			this.getTableMainList(this.queryMap);
		},
		methods: {
			showDetailChange(e) {
				e == true ? (this.activeName = "1") : (this.activeName = "0");
			},
			//   ------------------------------------------------------------
			// 双击主表格确认
			async handleSelectClick(row) {
				// 是否可选择明细
				if (this.isDetail) {
					return this.$message.error("请选择明细");
				}
				if (this.tableData && this.tableData.length) {
					let queryMap = {
						woamId: row[this.searchKey],
						extractId: this.queryMap.extractId,
					};
					await this.getTableDetailList(queryMap);
				}
				row.fromExtractDetailList = this.detailData;
				this.$emit("fromExtractEvent", row);
			},
			// 勾选明细
			handleSelectionChange(val) {
				this.multipleSelection = val;
				if (val.length) {
					this.detailsub = false;
				} else {
					this.detailsub = true;
				}
			},
			sureDetail() {
				this.objList.fromExtractDetailList = this.multipleSelection;
				this.$emit("fromExtractEvent", this.objList);
			},
			// 单击表格
			handleClick(row) {
				this.objList = row;
				let queryMap = {
					id: row[this.searchKey],
					extractId: this.queryMap.extractId,
				};
				this.getTableDetailList(queryMap);
			},
			// 检索条件赋值
			handleChange(value, name) {
				// value默认参，name当前所需的name
				this.queryMap[name] = value;
			},
			//   查询
			searchData() {
				this.currentPage = 1;
				this.queryMap.page = 1;
				this.getTableMainList(this.queryMap);
			},
			// 查询弹窗表格
			async getTableMainList(params) {
				let res = await this.$http.queryExtractPlanMainVo(params);
				this.total = res.total;
				this.tableData = res.rows; //默认第一条
				if (this.tableData && this.tableData.length) {
					this.objList = this.tableData[0];
					let queryMap = {
						id: this.tableData[0][this.searchKey],
						extractId: this.queryMap.extractId,
					};
					this.getTableDetailList(queryMap);
				} else {
					this.objList = [];
				}
				this.$refs.multipleTable.doLayout();
			},
			// 获取明细表格
			async getTableDetailList(params) {
				let res = await this.$http.queryExtractPlanDetailVo(params);
				this.detailData = res.rows;
			},
			handleSizeChange(val) {
				this.pageSize = val;
				this.queryMap.rows = val;
				this.getTableMainList(this.queryMap);
			},
			handleCurrentChange(val) {
				this.currentPage = val;
				this.queryMap.page = val;
				this.getTableMainList(this.queryMap);
			},
			//   -----------------------------------------------------
			getHeaderCellStyle() {
				return "background: skybule; borderBottom: solid 1px #5a5e66;color: #3e5569";
			},
			getHeaderCellStyleD() {
				return "background: skybule;color: #3e5569";
			},
		},
	};
</script>
<style scoped>
	.el-pagination {
		padding: 20px 0px 5px;
	}
</style>